/** @jsx jsx */
import * as React from 'react';
import { jsx } from '@balance-web/core';
import { Stack } from '@balance-web/stack';

export type AppLayoutProps = {
  header?: React.ReactNode;
  children: React.ReactNode;
};

export const AppLayout = ({ header, children }: AppLayoutProps) => {
  return (
    <Stack flexGrow={1} minHeight="100vh">
      {header}
      <Stack flexGrow={1}>{children}</Stack>
    </Stack>
  );
};
